import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Chapter2Header from "./Chapter2Header";
import ChapterCreate from "./ChapterCreate";

const Chapter = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Chapter2Header />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <ChapterCreate />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Chapter;
